import { useRecoilState } from "recoil";
import { tokenAtom } from "../atoms/atom";

export function useToken() {
  const [token, setToken] = useRecoilState(tokenAtom);
  
  return { token, setToken } as const;
}